<template>
  <div class="is-fullwidth">
    <div class="is-clearfix">
      <nuxt-link
        class="button is-primary is-pulled-right"
        :to="localePath('office-industries-create')"
        >{{ $t("form.create") }}</nuxt-link
      >

      <h1 class="is-size-3">{{ $t("page.industries") }}</h1>
    </div>

    <pagination-control
      :disablePager="true"
      :controls="{ type, filter }"
      :pagination="$store.state.users.pagination"
      :additionalFilter="typeFilter"
    />

    <div class="table-wrapper" ref="tableWrapper">
      <table
        class="table m-t-5 is-striped is-fullwidth"
        ref="table"
        v-if="$store.getters['industries/listForTable'].length"
      >
        <thead>
          <tr>
            <th>{{ $t("form.name") }}</th>
            <th>{{ $t("form.city") }}</th>
            <th>{{ $t("form.type") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="industry in $store.getters['industries/filteredList']"
            :key="industry.id"
          >
            <th>
              <nuxt-link
                :to="
                  localePath({
                    name: 'office-industries-id',
                    params: { id: industry.id },
                  })
                "
                >{{ industry.name }}</nuxt-link
              >
            </th>
            <td>{{ industry.city }}</td>
            <td>{{ $t("form." + industry.type) }}</td>
          </tr>
        </tbody>
      </table>
      <div v-else>{{ $t("message.no_data") }}</div>
    </div>
    <span
      v-if="showSwipeIcon"
      class="mdi mdi-gesture-swipe-horizontal has-text-primary"
      style="font-size: 25px"
    ></span>
  </div>
</template>

<script>
export default {
  watchQuery: true,

  async asyncData({ store, query, params }) {
    if (!params.skipReloding) {
      await store.dispatch("industries/filterIndustries", query);
    }

    let objToReturn = {};

    objToReturn.filter = query.filter;
    objToReturn.type = query.type;

    return objToReturn;
  },

  data() {
    return {
      type: "",
      typeFilter: {
        name: "type",
        label: this.$t("form.type") + ":",
        options: [
          {
            id: "",
            name: this.$t("form.all"),
          },
          {
            id: "glass",
            name: this.$t("form.glass"),
          },
          {
            id: "metal",
            name: this.$t("form.metal"),
          },
          {
            id: "wood",
            name: this.$t("form.wood"),
          },
          {
            id: "stone",
            name: this.$t("form.stone"),
          },
          {
            id: "hinge",
            name: this.$t("form.hinge"),
          },
        ],
      },
    };
  },

  computed: {
    showSwipeIcon() {
      return (
        this.isMounted &&
        this.$refs.table &&
        this.$refs.table.scrollWidth > this.$refs.tableWrapper.clientWidth
      );
    },
  },
};
</script>




// WEBPACK FOOTER //
// resources/nuxt/pages/office/industries/index.vue